import { palette } from '../components/chat/answerParts';

/**
 * themeFromConfig — resolved server config -> the `c` palette object every
 * chat surface consumes. With no config it returns exactly palette(isDark),
 * keeping config-less embeds pixel-identical to the pre-config widget.
 *
 * The server (site_settings.resolve_widget_config) fills every derived color,
 * so this stays a mapping, not color math. font_family is an enum — raw CSS
 * never flows from config into the page.
 */

const FONT_STACKS = {
  system: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  inter: "'Inter', -apple-system, sans-serif",
  georgia: "Georgia, 'Times New Roman', serif",
  arial: "Arial, Helvetica, sans-serif",
};

export function themeFromConfig(config, fallbackTheme = 'light') {
  const isDark = (config && config.theme ? config.theme : fallbackTheme) === 'dark';
  const base = palette(isDark);
  if (!config || !Object.keys(config).length) return { ...base, font: FONT_STACKS.system };
  return {
    ...base,
    accent: config.accent_color || base.accent,
    botBubble: config.bubble_bot_bg || base.botBubble,
    text: config.bubble_bot_text || base.text,
    userBubble: config.bubble_user_bg || config.accent_color || base.accent,
    userText: config.bubble_user_text || base.userText,
    headerBg: config.header_bg_color || config.accent_color || base.accent,
    headerText: config.header_text_color || '#ffffff',
    accentText: config.accent_text_color || '#ffffff',
    font: FONT_STACKS[config.font_family] || FONT_STACKS.system,
  };
}

export default themeFromConfig;
